import React, { useEffect, useState } from 'react';
import { Box, keyframes } from '@chakra-ui/react';
import { Search } from '@mui/icons-material';

const WORDS = ['Shirts', 'Jeans', 'Jackets', 'Tees', 'Blazers'];

const slideUp = keyframes`
  from { transform: translateY(100%); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

// 250×48 pill with "Search for" + a word that rotates every 2.5s (design-system.md §3.2).
// It opens the search panel, where the typing happens.
const SearchPill = ({ onOpen }) => {

    const [word, setWord] = useState(0);
    useEffect(() => {
        const timer = setInterval(() => setWord(w => (w + 1) % WORDS.length), 2500);
        return () => clearInterval(timer);
    }, []);

    return (
        <Box as='button' type='button' aria-label='Search products' onClick={onOpen} width='250px' height='48px' borderRadius='searchPill' border='1px solid' borderColor='raano.border' display='flex' alignItems='center' gap='8px' pl='16px' pr='12px' fontSize='15px' transition='border-color .125s' _hover={{ borderColor: 'raano.black' }} >
            <Search sx={{ fontSize: 22 }} />
            <Box as='span' color='blackAlpha.500' >Search for</Box>
            <Box as='span' position='relative' overflow='hidden' height='22px' display='inline-flex' alignItems='center' >
                <Box key={word} as='span' animation={`${slideUp} .35s ease-out`} >{WORDS[word]}</Box>
            </Box>
        </Box>
    );
};

export default SearchPill;
